import React from 'react'

import { Helmet } from 'react-helmet'

import TopMenu from '../components/top-menu'
import Footer from '../components/footer'
import './radix-wallet-redo.css'

const RadixWalletRedo = (props) => {
  return (
    <div className="radix-wallet-redo-container1">
      <Helmet>
        <title>Radix Wallet Redesign Proposal | Vlad Butucariu</title>
        <meta
          name="description"
          content="An independent Radix Wallet redesign proposal focused on account organization, navigation, NFT browsing, and clearer settings."
        />
        <meta
          property="og:title"
          content="Radix Wallet Redesign Proposal | Vlad Butucariu"
        />
        <meta
          property="og:description"
          content="A product design exploration based on first-hand use and recurring community feedback."
        />
        <meta
          property="og:image"
          content="https://vladbutucariu.com/Images/og-default.png"
        />
        <link
          rel="canonical"
          href="https://vladbutucariu.com/radix-wallet-redo"
        />
        <meta
          property="og:url"
          content="https://vladbutucariu.com/radix-wallet-redo"
        />
      </Helmet>
      <div className="radix-wallet-redo-thq-wrapper-elm">
        <TopMenu text3="Capabilities"></TopMenu>
        <div className="radix-wallet-redo-thq-top-section-elm">
          <div className="radix-wallet-redo-thq-video-div-elm">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="radix-wallet-redo-video"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="radix-wallet-redo-thq-video-mobile-elm"
            ></video>
          </div>
          <div className="radix-wallet-redo-thq-section-elm1">
            <div className="radix-wallet-redo-thq-color-wrapper-elm1 project-page-shell">
              <div className="radix-wallet-redo-container2 project-page-intro">
                <div className="radix-wallet-redo-container3">
                  <div className="radix-wallet-redo-container4">
                    <img
                      alt="image"
                      src="/Images/tickerpurple.200.svg"
                      className="radix-wallet-redo-image10"
                    />
                    <div className="radix-wallet-redo-thq-title-elm">
                      <h1 className="radix-wallet-redo-text10 header-project">
                        <span>Radix – Wallet Redesign</span>
                        <br></br>
                        <br></br>
                      </h1>
                    </div>
                    <div className="radix-wallet-redo-thq-subtitle-elm">
                      <div className="radix-wallet-redo-thq-description-elm1">
                        <h2 className="radix-wallet-redo-thq-heading-elm">
                          This independent Radix Wallet redesign combines
                          first-hand use with recurring community feedback. The
                          concept refines account organization, navigation, NFT
                          browsing, and settings while respecting the
                          established product and brand language.
                        </h2>
                      </div>
                      <div className="radix-wallet-redo-thq-tags-elm">
                        <label className="tag-label-big radix-wallet-redo-text14">
                          mobile app
                        </label>
                        <label className="radix-wallet-redo-text15 tag-label-big">
                          ux/ui
                        </label>
                        <label className="tag-label-big radix-wallet-redo-text16">
                          concept
                        </label>
                        <a
                          href="https://radixdlt.com"
                          target="_blank"
                          rel="noreferrer noopener"
                          className="radix-wallet-redo-link"
                        >
                          <label className="radix-wallet-redo-text17 tag-label-big">
                            https://radixdlt.com
                          </label>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="radix-wallet-redo-thq-description-elm2">
                  <div className="radix-wallet-redo-container5">
                    <span className="radix-wallet-redo-text18">context</span>
                    <span className="radix-wallet-redo-text19">
                      Launched alongside the Babylon network upgrade, the wallet
                      introduced new capabilities such as interacting with smart
                      contracts and managing on-ledger personas. While the
                      interface was visually clean and elevated many of Radix’s
                      core features, the user experience revealed several
                      friction points — especially around navigation, account
                      organization, and content hierarchy. The goal of this
                      redesign was to streamline these interactions and reduce
                      user confusion without disrupting the existing design
                      identity.
                    </span>
                  </div>
                  <div className="radix-wallet-redo-container6">
                    <span className="radix-wallet-redo-text20">Design</span>
                    <span className="radix-wallet-redo-text21">
                      <span>
                        As both a product designer and an active user of the
                        Radix Wallet, I began by combining first-hand experience
                        with extensive community feedback gathered from social
                        channels and user forums. Three key problem areas
                        consistently emerged. The first was account management
                        confusion — many users held multiple seed phrases and
                        accounts, yet the wallet displayed everything under a
                        single hierarchy, making it unclear which accounts
                        belonged to which seed and leading to excessive
                        scrolling. To solve this, I introduced a grouping system
                        that allowed users to toggle between seed phrases and
                        instantly view their associated accounts, creating a
                        more structured overview and reducing cognitive load for
                        those managing large portfolios.
                      </span>
                      <br></br>
                      <br></br>
                      <span>
                        The second issue was the lack of navigation structure.
                        Without a persistent navigation menu, users had to
                        repeatedly backtrack to return to the dashboard. While
                        this approach maintained a clean aesthetic, it
                        compromised usability. To address this, I reintroduced a
                        bottom navigation bar featuring customizable shortcuts
                        for essential actions such as Dashboard, QR Scanner,
                        Connected DApps, and Personas, enhancing accessibility
                        and enabling users to tailor their navigation to their
                        habits.
                      </span>
                      <br></br>
                      <br></br>
                      <span>
                        The third problem was inefficient NFT and badge
                        browsing. Collections were displayed in a lengthy
                        accordion format that made it difficult to scan or
                        switch between items, especially in large sets. I
                        replaced this with a grid layout, providing a compact,
                        visually clear overview while allowing users to access
                        full image previews when needed.
                      </span>
                      <br></br>
                      <br></br>
                      <span>
                        In addition, I refined the Settings panel, which had
                        previously buried key options within multiple nested
                        layers. The redesign adopted a more open, scroll-based
                        layout, surfacing all important settings at a glance and
                        dramatically simplifying navigation.
                      </span>
                    </span>
                  </div>
                  <div className="radix-wallet-redo-container7">
                    <span className="radix-wallet-redo-text32">
                      Design Outcome
                    </span>
                    <span className="radix-wallet-redo-text33">
                      The proposal demonstrates how a clearer hierarchy and
                      persistent navigation could reduce repeated backtracking
                      and make large portfolios easier to scan. It was submitted
                      as a concept and is presented here as design exploration,
                      not as shipped product work or a measured usability result.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="radix-wallet-redo-thq-section-elm2">
          <div className="radix-wallet-redo-thq-label-elm">
            <span className="radix-wallet-redo-text34">Loopers</span>
            <span className="radix-wallet-redo-text35">
              animation, nft, collection, art
            </span>
          </div>
          <div className="radix-wallet-redo-container8">
            <div className="radix-wallet-redo-thq-item-elm10">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="radix-wallet-redo-image11"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm11">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="radix-wallet-redo-image12"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm12">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="radix-wallet-redo-image13"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm13">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="radix-wallet-redo-image14"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm14">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="radix-wallet-redo-image15"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm15">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="radix-wallet-redo-image16"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm16">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="radix-wallet-redo-image17"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm17">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="radix-wallet-redo-image18"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm18">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="radix-wallet-redo-image19"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm19">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="radix-wallet-redo-image20"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm20">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="radix-wallet-redo-image21"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm21">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="radix-wallet-redo-image22"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm22">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="radix-wallet-redo-image23"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm23">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="radix-wallet-redo-image24"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm24">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="radix-wallet-redo-image25"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm25">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="radix-wallet-redo-image26"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm26">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="radix-wallet-redo-image27"
              />
            </div>
            <div className="radix-wallet-redo-thq-item-elm27">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="radix-wallet-redo-image28"
              />
            </div>
          </div>
        </div>
        <div className="radix-wallet-redo-thq-section-elm3">
          <div className="radix-wallet-redo-thq-color-wrapper-elm2">
            <div className="radix-wallet-redo-container9">
              <div className="radix-wallet-redo-thq-pic-elm">
                <img
                  alt="image"
                  src="/Projects/radix%20wallet%20proposal%20-%20accounts.png"
                  className="radix-wallet-redo-image29"
                />
                <img
                  alt="image"
                  src="/Projects/radix%20wallet%20proposal%20-%20nfts.png"
                  className="radix-wallet-redo-image30"
                />
                <img
                  alt="image"
                  src="/Projects/radix%20wallet%20proposal%20-%20dark%20mode.png"
                  className="radix-wallet-redo-image31"
                />
                <img
                  alt="image"
                  src="/Projects/radix%20wallet%20proposal%20-%20settings.png"
                  className="radix-wallet-redo-image32"
                />
              </div>
            </div>
          </div>
        </div>
        <Footer rootClassName="footerroot-class-name6"></Footer>
      </div>
    </div>
  )
}

export default RadixWalletRedo
